import { CardTypes } from 'defs/card-types';
import { ProgramDaysActionType } from 'store/programDays/programDays.actionCreators';
import * as programDaysAT from 'store/programDays/programDays.actionTypes';
import { initialState } from 'store/programItems';
import { ProgramItemStateType } from 'store/programItems';
import { actionTypes as programPreviewAT } from 'store/programPreview';
import { ProgramPreviewActionType } from '../programPreview/programPreview.actionCreators';
import { ProgramItemsActionType } from './programItems.actionCreators';
import {
	FLUSH_PROGRAM_ITEMS,
	REPLACE_ITEM,
	REPLACE_ITEM_CONTENTS,
	REQUEST_CLOSE_SUCCESS,
	REQUEST_COMPLETED_SUCCESS,
	REQUEST_CONTENTS_SUCCESS,
	REQUEST_MOVE_ITEM_SUCCESS,
	REQUEST_SAVE_PORTION_SELECTION,
	REQUEST_SAVE_TRACKING,
	REQUEST_SAVE_TRACKING_FAILURE,
	REQUEST_SAVE_TRACKING_SUCCESS,
	REQUEST_SLOGAN_SUCCESS,
	REQUEST_TOGGLE_FAVORITE_SUCCESS,
	REQUEST_UPDATE_TRACKING,
	REQUEST_UPDATE_TRACKING_FAILURE,
	REQUEST_UPDATE_TRACKING_SUCCESS,
	SET_ITEM_IS_CUSTOM,
} from './programItems.actionTypes';

export default (
	state: ProgramItemStateType = initialState,
	action: ProgramItemsActionType | ProgramDaysActionType | ProgramPreviewActionType
) => {
	switch (action.type) {
		case FLUSH_PROGRAM_ITEMS:
		case programPreviewAT.START_SUCCESS:
		case programPreviewAT.OVERWRITE_SUCCESS:
			return { ...initialState };

		case REQUEST_TOGGLE_FAVORITE_SUCCESS:
			let newByIdState = state.byId;

			if (action.itemType === CardTypes.DynamicProduct) {
				newByIdState = {
					...state.byId,
					[action.id]: {
						...state.byId[action.id],
						addedToRemovePipeline: true,
					},
				};
			} else {
				newByIdState = {
					...state.byId,
					[action.id]: {
						...state.byId[action.id],
						favorite: action.favorite,
					},
				};
			}

			return {
				...state,
				byId: newByIdState,
			};

		case programDaysAT.REQUEST_TODAY_SUCCESS:
		case programDaysAT.REQUEST_DAY_SUCCESS:
			return {
				...state,
				byId: {
					...state.byId,
					...action.day.programItems.reduce((acc, programItem) => {
						acc[programItem.id] = {
							...programItem,
						};
						return acc;
					}, {}),
				},
			};

		case SET_ITEM_IS_CUSTOM:
			const programItemId = action.programItemId;
			const existingItem = state.byId[programItemId];

			return {
				...state,
				byId: {
					...(state.byId || {}),
					[programItemId]: {
						...state.byId[programItemId],
						isCustom: true,
					},
				},
				contentByExternalId: {
					...state.contentByExternalId,
					[existingItem.externalId || 'invalid-external-id']: {
						fallbackImage: (state.contentByExternalId[existingItem.externalId || ''] || {}).fallbackImage,
					},
				},
			};

		case REQUEST_MOVE_ITEM_SUCCESS:
			return {
				...state,
				byId: {
					...(state.byId || {}),
					[action.programItemExternalId]: {
						...state.byId[action.programItemExternalId],
						isPostponed: true,
					},
				},
			};

		case REPLACE_ITEM:
			return {
				...state,
				byId: {
					...(state.byId || {}),
					[action.programItem.id]: action.programItem,
				},
			};

		case REQUEST_SAVE_TRACKING:
		case REQUEST_UPDATE_TRACKING:
			return {
				...state,
				isUpdatingTracking: true,
			};

		case REQUEST_SAVE_PORTION_SELECTION as any:
			return {
				...state,
				byId: {
					...state.byId,
					[(action as any).id]: {
						...state.byId[(action as any).id],
						ingredientValueSelection: (action as any).portionValue,
					},
				},
			};

		case REQUEST_SAVE_TRACKING_SUCCESS:
		case REQUEST_UPDATE_TRACKING_SUCCESS:
			const newState = {
				...state,
				byId: {
					...(state.byId || {}),
					[action.programItem.id]: action.programItem,
				},
				isUpdatingTracking: false,
			};

			Object.keys(newState.byId).forEach((key: string) => {
				const item: any = newState.byId[key];
				if (
					item.type === 'TrackingProgramItem' &&
					item.selectedContentType &&
					item.selectedContentType &&
					action.programItem &&
					action.programItem.selectedContentType &&
					action.programItem.selectedContentType.date
				) {
					item.selectedContentType = { ...action.programItem.selectedContentType };
				}
			});

			return newState;

		case REQUEST_SAVE_TRACKING_FAILURE as any:
		case REQUEST_UPDATE_TRACKING_FAILURE as any:
			return {
				...state,
				isUpdatingTracking: false,
			};

		case REQUEST_COMPLETED_SUCCESS:
			return {
				...state,
				byId: {
					...(state.byId || {}),
					[action.programItem.id]: action.programItem,
				},
			};

		case REQUEST_SLOGAN_SUCCESS:
			return {
				...state,
				byId: {
					...(state.byId || {}),
					[action.programItem.id]: action.programItem,
				},
			};

		case REPLACE_ITEM_CONTENTS:
			const contentAllExternalIds: string[] = ([] as string[]).concat(state.contentAllExternalIds);
			const externalId: string = action.programItemContents.externalId;
			if (contentAllExternalIds.indexOf(externalId) < 0) {
				contentAllExternalIds.push(externalId);
			}

			return {
				...state,
				byId: {
					...state.byId,
					[action.programItemId]: {
						...state.byId[action.programItemId],
					},
				},
				contentAllExternalIds,
				contentByExternalId: {
					...state.contentByExternalId,
					[action.programItemContents.externalId]: action.programItemContents,
				},
			};

		case REQUEST_CONTENTS_SUCCESS:
			return {
				...state,
				contentAllExternalIds: [
					...state.contentAllExternalIds,
					...action.programItemsContents
						.map((item) => item.externalId)
						.filter((itemExternalId) => {
							return (
								state.contentAllExternalIds.findIndex((entryId) => entryId === itemExternalId) === -1
							);
						}),
				],
				contentByExternalId: {
					...state.contentByExternalId,
					...action.programItemsContents.reduce((acc, cur) => {
						acc[cur.externalId] = cur;
						return acc;
					}, {}),
				},
			};

		case REQUEST_CLOSE_SUCCESS:
			return {
				...state,
				byId: {
					...state.byId,
					[action.programItem.id]: action.programItem,
				},
			};

		default:
			return state;
	}
};
